<template>
  <div class="h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0">
    <el-tabs type="border-card">
      <el-tab-pane
          v-for="(tab, index) in tabs"
          :key="index"
          :label="tab.name"
          @click="(e) => setTab(e, tab.name)"
      >
        <ClaimsTypeList v-if="index == 0"></ClaimsTypeList>
        <ClaimWorkflows v-if="index == 1"></ClaimWorkflows>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// Other setups
import ClaimsTypeList from "@/components/CompanySetups/claimTypes/claimTypeList.vue";
import ClaimWorkflows from "@/components/CompanySetups/claimWorkflow/claimWorkflowList.vue";

export default {
  name: "ClaimsSetupsTabs",
  props: ["setup"],
  components: {
    ClaimsTypeList,
    ClaimWorkflows,
  },
  data() {
    return {
      selectedTab: "Claim Types",
      teamKey: 0,
      mineKey: 1,
      isApproved: true,
      isDeclined: false,

      cTKey: 0,
      cWKey: 1,
      cMKey: 2,

      tabs: [
        {
          name: "Claim Types",
          route: "claim-types",
        },
        {
          name: "Claim Workflows",
          route: "claim-workflows",
        },
      ],
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
  watch: {
    $route(to) {
      this.tabs.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
        }
      });
      switch (this.selectedSubMenu) {
        case "Claim Types":
          this.tTKey++;
          break;
        case "Claim Workflows":
          this.tWKey++;
          break;
      }
    },
  },
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
